enum FilterStatus {
    Filter = 'Filter',
    Error = 'Error',
    Warning = 'Warning'
}

export default FilterStatus;